import React from 'react';
import { CommandButtonGroup } from './styles';

interface Option {
  label: string;
  min: number;
  max: number | undefined;
}

interface FilterButtonGroupProps {
  options: Option[];
  minState: number | undefined;
  maxState: number | undefined;
  onClick: (min: number, max: number | undefined) => void;
}

const ButtonGroup: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <CommandButtonGroup className="mt-2 flex flex-shrink-0 items-center md:mt-0">
    {children}
  </CommandButtonGroup>
);

export const FilterButtonGroup: React.FC<FilterButtonGroupProps> = ({
  options,
  minState,
  maxState,
  onClick,
}) => {
  const isActive = (min: number, max: number | undefined): boolean =>
    minState === min && maxState === max;

  return (
    <ButtonGroup>
      <div className="flex flex-wrap gap-1">
        {options.map((option, index) => (
          <button
            key={index}
            type="button"
            className={`items-center rounded-[4px] border px-2 py-1.5 text-xs  font-semibold leading-tight transition-colors
              sm:mr-1 sm:px-3 sm:py-2 sm:leading-none
              ${
                isActive(option.min, option.max)
                  ? 'bg-white text-brand-primary'
                  : 'border-gray-600 text-white hover:border-gray-400'
              }`}
            onClick={() => onClick(option.min, option.max)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </ButtonGroup>
  );
};
